import { createBrowserRouter } from "react-router-dom";
import { Suspense } from "react";
import FrameStructure from "../layout/FrameStructure";
import { sharedRoutes } from "./sharedRoutes";
import { sellerRoutes } from "./sellerRoutes";
import { buyerRoutes } from "./buyerRouters";
import { UnCompletedAccountRoutes } from "./UnCompletedAccount";
import LandingPage from "../pages/commanPage/landingPages/LandingPage";
import LoginComponent from "../pages/auth/components/LoginComponent";
import CompleteAccountSetup from "../pages/auth/components/CompleteAccountSetup"
import PhoneNumberRegister from "../pages/auth/components/PhoneNumberRegister";
import RegisterFrame from "../pages/auth/RegisterFrame";
import OtpVerification from "../pages/auth/components/OtpVerification";
import UserDetails from "../pages/auth/components/UserDetails";
import LiveRoomForLots from "../pages/buyerAuction/liveroom/updateLiveRoom/auctionTypeComponent/LiveRoomForLots";
import LiveRoomStructur from "../pages/buyerAuction/liveroom/updateLiveRoom/liveRoomFrame/LiveRoomStructur";
import CatalogueViewInLiveRoom from "../pages/buyerAuction/liveroom/updateLiveRoom/liveRoomFrame/components/CatalogueViewInLiveRoom";
import BuyerTodayAuctions from "../pages/buyerAuction/liveroom/pages/BuyerTodayAuctions";
import PageNotFound from "../pages/commanPage/errorPage/PageNotFound";
import ThankParticipationPage from "../pages/buyerAuction/liveroom/updateLiveRoom/children/ThankParticipationPage";
import ServiceLiveForLots from "../pages/buyerAuction/liveroom/updateLiveRoom/auctionTypeComponent/ServiceLiveForLots";
import ProductLiveForLots from "../pages/buyerAuction/liveroom/updateLiveRoom/auctionTypeComponent/ProductLiveForLots";

export const modifiedSellerRoutes = createBrowserRouter([
  {
    path: "/",
    element: (
      <Suspense fallback={<div>loading...</div>}>
        <FrameStructure />
      </Suspense>
    ),

    children: [...sellerRoutes, ...sharedRoutes],
  },
]);

export const modifiedBuyerRoutes = createBrowserRouter([
  {
    path: "/",
    element: (
      <Suspense fallback={<div>loading...</div>}>
        <FrameStructure />
      </Suspense>
    ),
    children: [...buyerRoutes, ...sharedRoutes],
  },
  {
    path: "/",
    element: <LiveRoomStructur />,
    children: [
      {
        path: "/forward-auction/live-room/:id/:catalogueId",
        element: <LiveRoomForLots />,
      },
      {
        path: "/reverse-service-auction/live-room/:id/:catalogueId",
        element: <ServiceLiveForLots />,
      },
      {
        path: "/reverse-product-auction/live-room/:id/:catalogueId",
        element: <ProductLiveForLots />,
      },
      {
        path: "/catalogue-live-room/:id",
        element: <CatalogueViewInLiveRoom />,
      },
      {
        path: "live-auctions",
        element: <BuyerTodayAuctions />,
      },
      {
        path: "thanks-for-participation",
        element: <ThankParticipationPage />,
      },
    ],
  },
]);

export const modifiedUnCompletedRoutes = createBrowserRouter(
  UnCompletedAccountRoutes
);

export const modifiedUnAuthorizedRoutes = createBrowserRouter([
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    element: <RegisterFrame />,
    children: [
      {
        path: "/login",
        element: <LoginComponent />,
      },
      {
        path: "/register/step-1",
        element: <PhoneNumberRegister />,
      },
      {
        path: "/otp-verification/step-2",
        element: <OtpVerification />,
      },
      {
        path: "/create-Account/step-3",
        element: <UserDetails />,
      },
      {
        path: "/create-Account/complete-account-setup",
        element: <CompleteAccountSetup />,
      },

    ],
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
]);

// {
//   path: "/confirm-otp",
//   element: <ConfirmOTP />
// },
// {
//   path: "/confirm-otp/:session",
//   element: <ConfirmOTP />
// },
